import React from 'react';
import cn from 'classnames';
import classes from './Grid.module.scss';

export const GridRow = ({ children, className, col = 1, gap = 16, style }) => {
  return (
    <div
      className={cn(classes.gridRow, className)}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${col}, 1fr)`,
        gap,
        ...(style || {}),
      }}
    >
      {children}
    </div>
  );
};
export const GridColumn = ({ children, className, colSpan = 1, style }) => {
  return (
    <div
      className={cn(classes.gridColumn, className)}
      style={{
        gridColumn: `span ${colSpan}`,
        ...(style || {}),
      }}
    >
      {children}
    </div>
  );
};
